import React from 'react';
import { Lock, X, Mail } from 'lucide-react';

const ADMIN_CONTACT = import.meta.env.VITE_ADMIN_CONTACT || 'your administrator';

export default function RequestAccessModal({ feature, featureLabel, onClose }) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#0f172a', border: '1px solid #1e293b', borderRadius: 12,
          width: 420, maxWidth: '90vw', padding: 24, color: '#e5e7eb',
          boxShadow: '0 20px 50px rgba(0,0,0,0.5)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, borderRadius: 8,
              background: 'rgba(251,191,36,0.15)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <Lock size={18} color="#fbbf24" />
            </div>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>Feature locked</h3>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 4 }}
          >
            <X size={18} />
          </button>
        </div>

        <p style={{ margin: '0 0 14px', fontSize: 14, color: '#cbd5e1', lineHeight: 1.5 }}>
          <strong style={{ color: '#fff' }}>{featureLabel}</strong> is not enabled for your account.
        </p>
        <p style={{ margin: '0 0 18px', fontSize: 13, color: '#94a3b8', lineHeight: 1.5 }}>
          To request access, contact your administrator. They can enable this feature
          from the Admin → Users panel.
        </p>

        <div style={{
          background: '#1e293b', border: '1px solid #334155', borderRadius: 8,
          padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10,
          marginBottom: 16
        }}>
          <Mail size={14} color="#94a3b8" />
          <span style={{ fontSize: 13, color: '#cbd5e1' }}>{ADMIN_CONTACT}</span>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%', padding: '9px 14px', borderRadius: 8,
            background: '#6366f1', color: '#fff', border: 'none',
            fontSize: 13, fontWeight: 500, cursor: 'pointer'
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
}
